module.exports = __webpack_public_path__ + "img/AntofagastaMinerals.37a6c3e7.jpg";